<div class="payment-static-error-wrapper">
  <div class="payment-static-status-icon">
    <img [src]="sanitizing.bypassSecurityTrustUrl(helperService.paymentStatusesIcons['FAILED'])" alt="error" />
  </div>
  <div class="payment-static-status-title">{{ 'payment.error_title' | translate }}</div>
  <div class="payment-static-status-description {{ !isRedirectShown ? 'mb-30' : null }}" *ngIf="isRedirectShown">
    {{ 'payment.status_description' | translate }}
  </div>
  <div
    *ngIf="isRedirectShown"
    class="payment-static-status-redirect-info mb-30"
    [innerHTML]="'payment.redirect_details' | translate: { callback_endpoint: callbackEndpoint }"
  ></div>
</div>
